import Vue from 'vue';
import travelMilestones from '@/views/plan/mapPlanFlod/travelMilestones.vue';

class CustomGroundOverlay extends BMapGL.GroundOverlay {
  constructor(citys) {
    super();
    this.citys = citys; // 传入的数据
  }

  initialize(map) {
    this._map = map;

    // 创建 Vue 组件
    const NodeConstructor = Vue.extend(travelMilestones);
    this.nodeInstance = new NodeConstructor({
      propsData: {
        citys: this.citys // 通过 props 传递数据
      }
    });

    // 挂载组件
    this.nodeInstance.$mount();
    this._div = this.nodeInstance.$el;
    // 添加到地图
    map.getPanes().markerPane.appendChild(this._div);
  }
}

export default CustomGroundOverlay;
